import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Fa from 'react-fontawesome';

class FieldLabelCellRenderer extends Component {
  renderContent() {
    const { value, data, paddingLeft, showStatus } = this.props;
    if (value && value !== null && data) {
      let label = (<span>{value}</span>);
      const id = data._id || data.id || data.name;
      const { description } = data;
      const hasDescription = description !== null && description !== undefined && description.length > 0;
      let infoComp = null;
      if (data.accessible === false) {
        label = (<span className="text-danger">{value}</span>);
        const tooltip = (
          <Tooltip id={id}>This field is no longer readable</Tooltip>
        );
        infoComp = (
          <OverlayTrigger placement="right" overlay={tooltip}>
            <Fa name="exclamation-triangle" className="text-danger" />
          </OverlayTrigger>
        );
      } else if (hasDescription) {
        const tooltip = (
          <Tooltip id={id}>{description}</Tooltip>
        );
        infoComp = (
          <OverlayTrigger placement="right" overlay={tooltip}>
            <Fa name="info-circle" className="text-active" />
          </OverlayTrigger>
        );
      }
      let starComp = null;
      if (data.is_default) {
        const startTooltip = (
          <Tooltip id={`${id}-star`}>Default Field</Tooltip>
        );
        starComp = (
          <OverlayTrigger placement="right" overlay={startTooltip}>
            <Fa name="star" className="text-warning" />
          </OverlayTrigger>
        );
      }
      const style = { paddingLeft };

      let star = null;
      if (showStatus) {
        star = (<Fa name="star" className={data.is_active ? 'text-warning' : 'invisible'} />);
      }
    
      return (<div style={style}>{star} {label} {starComp} {infoComp}</div>);
    }
    return null;
  }
  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderContent();
    }
    return null;
  }
}

FieldLabelCellRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    description: PropTypes.string,
    is_default: PropTypes.bool,
    accessible: PropTypes.bool,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }).isRequired,
  paddingLeft: PropTypes.number,
  showStatus: PropTypes.bool,
};
FieldLabelCellRenderer.defaultProps = {
  value: null,
  paddingLeft: null,
  showStatus: false,
  data: null,
};

export default FieldLabelCellRenderer;
